import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { QuestionsDashboardQueryKeys } from "modules/QuestionsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Question } from "models";

type CreateQuestionPayload = Pick<Question, "title" | "dealer_id">;

export const useCreateQuestionMutation = () =>
  useTypedMutation<CreateQuestionPayload, Question>({
    mutationFn: async payload => (await ApiInstance.post("/questions/create", payload, ENV.dealerBaseURL)).data.question,
    onSuccess: ({ dealer_id }, createdQuestion) => {
      const queryKey = dealer_id ? QuestionsDashboardQueryKeys.dealerQuestions(dealer_id) : QuestionsDashboardQueryKeys.defaultQuestions;
      const questions = typedQueryClient.getQueryData(queryKey) ?? [];
      if (questions.some(question => question.id === createdQuestion.id)) return;

      typedQueryClient.setQueryData(queryKey, [{ ...createdQuestion, active: true }, ...questions]);
    }
  });
